const ENABLED_SOURCES = new Set(['2352:yunibuffa.com']);

const isEnabled = ({ Brand_id, domain }) => ENABLED_SOURCES.has(`${Brand_id}:${domain}`);

module.exports = {
  isEnabled
};
